import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import NewHeader from "./NewHeader";
import NotifictionBar from "./home/NotifictionBar";
import Footer from "./Footer";
import NewFooter from "./NewFooter";
import { CurrencyProvider } from "../context/CurrencyContext";


const Layout = () => {
  return (
    <div id="main-layout-container" className="min-h-screen overflow-visible bg-page inline-flex flex-col min-w-full">
      {/* <NotifictionBar /> */}
      <CurrencyProvider>
      <NewHeader />
      {/* <Header /> */}
      <main className="flex-2">
        <Outlet />
      </main>
      {/* <Footer /> */}
      <NewFooter />
      </CurrencyProvider>
    </div>
  );
};
export default Layout;